module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/sepa-payment-card-cb45b90baf1c653420628e703ad8aa7c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/sepa-payment-card.svg
// module id = SqV8
// module chunks = 24